import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[11px] font-semibold tracking-[0.08em] uppercase transition-colors duration-200",
  {
    variants: {
      variant: {
        default: "border-kin-green/20 bg-kin-green/10 text-kin-green-dark backdrop-blur-sm",
        gold: "border-kin-gold/30 bg-kin-gold/10 text-kin-gold-dark backdrop-blur-sm",
        orange: "border-kin-orange/20 bg-kin-orange/10 text-kin-orange backdrop-blur-sm",
        lavender: "border-kin-lavender/30 bg-kin-lavender/10 text-kin-lavender backdrop-blur-sm",
        solidGreen: "border-kin-green-dark/10 bg-kin-green text-white shadow-sm",
        solidGold: "border-kin-gold-dark/10 bg-kin-gold text-kin-black shadow-sm",
        solidOrange: "border-transparent bg-kin-orange text-white shadow-sm",
        solidOlive: "border-transparent bg-kin-olive text-white shadow-sm",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => (
  <span className={cn(badgeVariants({ variant, className }))} ref={ref} {...props} />
));

Badge.displayName = "Badge";

export { Badge };
